import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "bg-white dark:bg-black p-2 z-10 relative flex justify-between items-center -m-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", { href: "/" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://assets.workbean.co/logo/v3/horizontal-2.png",
    alt: "Workbean",
    class: "h-5 dark:hidden flex"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://assets.workbean.co/logo/v3/horizontal-white.png",
    alt: "Workbean",
    class: "h-5 hidden dark:flex"
  })
], -1)
const _hoisted_3 = { class: "flex flex-row items-center justify-center gap-5" }
const _hoisted_4 = {
  key: 0,
  class: "text-primary-violet text-base bg-white rounded-xl py-2 px-5 font-medium",
  href: "/login"
}
const _hoisted_5 = { class: "" }
const _hoisted_6 = ["href"]
const _hoisted_7 = ["onClick"]

import { computed } from "vue"
  import { useAuthenticationStore } from "@/store/authentication"
  import { useUserStore } from "@/store/user"
  import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/vue"

  import WbAvatar from "@/components/template/avatarTemplate.vue"
  import WbButton from "@/components/template/buttonTemplate.vue"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'menuBar',
  setup(__props) {

  const authenticationStore = useAuthenticationStore()
  const userStore = useUserStore()

  const userDropDown = computed(() => [
    {
      name: "Solutions Page",
      link: "/solutions",
      type: "route",
    },
    {
      name: "Account Settings",
      link: "/account-login-and-security",
      type: "route",
    },
    {
      name: "Logout",
      link: authenticationStore.logout,
      type: "function",
    },
  ])

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (!_unref(authenticationStore).token)
        ? (_openBlock(), _createElementBlock("a", _hoisted_4, "Sign In"))
        : _createCommentVNode("", true),
      _createVNode(_unref(Menu), {
        as: "div",
        class: "relative inline-block text-left"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_unref(MenuButton), null, {
              default: _withCtx(() => [
                (_unref(authenticationStore).token)
                  ? (_openBlock(), _createBlock(WbAvatar, {
                      key: 0,
                      name: _unref(userStore).customerDetails.profile.name.first_name,
                      image: _unref(userStore).customerDetails.profile.photo,
                      color: "#F8EEF0"
                    }, null, 8, ["name", "image"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createVNode(_Transition, {
            "enter-active-class": "transition duration-100 ease-out",
            "enter-from-class": "transform scale-95 opacity-0",
            "enter-to-class": "transform scale-100 opacity-100",
            "leave-active-class": "transition duration-75 ease-in",
            "leave-from-class": "transform scale-100 opacity-100",
            "leave-to-class": "transform scale-95 opacity-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(MenuItems), { class: "absolute right-0 mt-2 w-56 p-4 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg focus:outline-none" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userDropDown), (dropdown, index) => {
                      return (_openBlock(), _createBlock(_unref(MenuItem), { key: index }, {
                        default: _withCtx(({ active }) => [
                          (dropdown.type === 'href')
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: dropdown.link,
                                class: _normalizeClass([active ? 'bg-primary-violet text-white' : 'text-primary-black', 'group flex w-full items-center rounded-md p-3'])
                              }, _toDisplayString(dropdown.name), 11, _hoisted_6))
                            : (dropdown.type === 'route')
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 1,
                                  to: dropdown.link,
                                  class: _normalizeClass([active ? 'bg-primary-violet text-white' : 'text-primary-black', 'group flex w-full items-center rounded-md p-3'])
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(dropdown.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to", "class"]))
                              : (_openBlock(), _createElementBlock("button", {
                                  key: 2,
                                  class: _normalizeClass([active ? 'bg-primary-violet text-white' : 'text-primary-black', 'group flex w-full items-center rounded-md p-3']),
                                  onClick: dropdown.link
                                }, _toDisplayString(dropdown.name), 11, _hoisted_7))
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})